module.exports = __webpack_public_path__ + "static/media/ecopolluters.a6fc8e23.svg";